import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { userHasAnyPermission, userHasPermission } from '../../utils/permissions';

type Props = Omit<RouteProps, 'component' | 'render' | 'children'> & {
  component: React.ComponentType<any>;
  permission?: string;
  permissions?: string[];
  requireAll?: boolean;
  authOnly?: boolean;
};

const PermissionRoute: React.FC<Props> = ({
  component: Component,
  permission,
  permissions,
  requireAll,
  authOnly,
  ...rest
}) => {
  const { user } = useAuth();

  const redirectFallback = () => {
    if (user?.role === 'photographer') return '/photographers-schedule';
    return '/schedules';
  };

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!user) {
          return <Redirect to="/" />;
        }
        if (authOnly) {
          return <Component {...props} />;
        }
        let allowed = false;
        if (permission) {
          allowed = userHasPermission(user, permission);
        } else if (permissions && permissions.length > 0) {
          allowed = requireAll
            ? permissions.every((k) => userHasPermission(user, k))
            : userHasAnyPermission(user, permissions);
        }
        if (!allowed) {
          return <Redirect to={redirectFallback()} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default PermissionRoute;
